import * as actionTypes from '../constants/actionType';
import * as apiActions from "./apiActions";
import * as apiValues from "../constants/apiValues";


//Action Creators
export const loadMLatestEventsStart = () => {
  return {
    type: actionTypes.MLATESTEVENTS_LOAD_START
  };
};
export const loadMLatestEventsFail = (error) => {
  console.error(error);
  return {
    type: actionTypes.MLATESTEVENTS_LOAD_FAIL,
    error
  };
};
export const loadMLatestEventsSuccess = (data) => {
  return {
    type: actionTypes.MLATESTEVENTS_LOAD_SUCCESS,
    data
  };
};


export const initMLatestEvents = params => dispatch => {
  dispatch(loadMLatestEventsStart());

  const futureEventsQuery = {
    EventDate_gt: new Date().toISOString(),
    _sort: 'EventDate:asc',
  };

  //get projects
  let eventsPromise;
  if (params.relatedProgram)
    eventsPromise = apiActions.loadEndpoint(apiValues.nref.event.endpoint, null, {
      Program_in: params.relatedProgram.id,
      ...futureEventsQuery,
    });
  else if (params.relatedProject)
    eventsPromise = apiActions.loadEndpoint(apiValues.nref.event.endpoint, null, {
      RelatedProject_in: params.relatedProject.id,
      ...futureEventsQuery,
    });
  else if (params.relatedTag)
    eventsPromise = apiActions.loadEndpoint(apiValues.nref.event.endpoint, null, {
      Tags_in: params.relatedTag.id,
      ...futureEventsQuery,
    });
  else if (params.program)
    eventsPromise = apiActions.loadEndpoint(apiValues.nref.event.endpoint, null, {
      Program_in: params.program.id,
      ...futureEventsQuery,
    });
  else
    eventsPromise = apiActions.loadEndpoint(apiValues.nref.event.endpoint, null, futureEventsQuery);

  return eventsPromise.then(results => {
    results = results.filter(item => {
      const raw = item.eventDate ?? item.EventDate;
      const eventDate = new Date(raw);

      if (!eventDate.getDate()) {
        return false;
      }
      const currentDate = new Date();
      return eventDate > currentDate;
    });
    results = results.sort(
      (a, b) => new Date(a.eventDate ?? a.EventDate) - new Date(b.eventDate ?? b.EventDate),
    );
    let mLatestEvents = {events: apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.event.fieldsUsed)};
    dispatch(loadMLatestEventsSuccess(mLatestEvents));

    return mLatestEvents;
  });

  //
  //
  //dispatch(loadMLatestEventsStart());
  //
  //let mLatestEvents = {};
  ////get projects
  //apiActions.loadEndpoint('events', null).then(results => {
  //  if (program) {
  //    results = results.filter(result => (result && result.Program) ? result.Program.id === program : false);
  //  }
  //  mLatestEvents.events = apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.event.fieldsUsed);
  //
  //  dispatch(loadMLatestEventsSuccess(mLatestEvents));
  //});
}
